class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      if (globalnum == 1) {
        event.preventDefault();
        this.open(cartLink);
      }

      let allitem_incart = document.querySelectorAll(
        "input.quantity__input.ac_cartdrawer"
      );
      let allremovebtn_item_incart = document.querySelectorAll(
        "button.cart-remove-button"
      );

      for (let i = 0; i < allitem_incart.length; i++) {
        let current_input_qty = parseInt(allitem_incart[i].value) || 0;
        let data_cart_qty =
          parseInt(allitem_incart[i].getAttribute("data-cart-quantity")) || 0;
        let cart_qty_maxvalue =
          parseInt(allitem_incart[i].getAttribute("max")) || 999;

        // Only adjust if current quantity exceeds stock limit
        if (current_input_qty > cart_qty_maxvalue) {
          let inputqty_parent = allitem_incart[i].parentElement;
          let minus_btn = inputqty_parent.querySelector(
            "button.quantity__button[name='minus']"
          );

          if (cart_qty_maxvalue == 0) {
            // Remove item from cart if no stock available
            allremovebtn_item_incart[i].click();
          } else {
            // Set quantity to maximum available stock
            allitem_incart[i].value = cart_qty_maxvalue;
            // Trigger change event to update cart
            allitem_incart[i].dispatchEvent(
              new Event("change", { bubbles: true })
            );
          }
        }
      }
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    var idSelectors;
    if (document.getElementById("main-cart-items") != null) {
      idSelectors = [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-drawer",
          selector: "#CartDrawer",
        },
        {
          id: "cart-icon-bubble",
        },
      ];
    } else {
      idSelectors = [
        {
          id: "cart-drawer",
          selector: "#CartDrawer",
        },
        {
          id: "cart-icon-bubble",
        },
      ];
    }
    return idSelectors;
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    var idSelectors;
    if (document.getElementById("main-cart-items") != null) {
      idSelectors = [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "CartDrawer",
          section: "cart-drawer",
          selector: ".drawer__inner",
        },
      ];
    } else {
      idSelectors = [
        {
          id: "CartDrawer",
          section: "cart-drawer",
          selector: ".drawer__inner",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
      ];
    }
    return idSelectors;
    // return [
    //   {
    //     id: 'CartDrawer',
    //     section: 'cart-drawer',
    //     selector: '.drawer__inner',
    //   },
    //   {
    //     id: 'cart-icon-bubble',
    //     section: 'cart-icon-bubble',
    //     selector: '.shopify-section',
    //   },
    // ];
  }

  autoRemoveGiftIfNeeded() {
  const GIFT_VARIANT_ID = 45341074292867;
  const THRESHOLD = 4;

  fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => {
      const paidItemCount = cart.items
        .filter((item) => item.variant_id !== GIFT_VARIANT_ID)
        .reduce((sum, item) => sum + item.quantity, 0);

      if (paidItemCount >= THRESHOLD) return;

      // Remove ALL gift duplicates
      const gifts = cart.items.filter((item) => item.variant_id === GIFT_VARIANT_ID);
      if (!gifts.length) return;

      return Promise.all(
        gifts.map((gift) =>
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: gift.key,
              quantity: 0,
            }),
          })
        )
      );
    })
    .then(() => {
      // If we removed something, refresh drawer contents again
      // (prevents stale drawer UI)
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch((e) => console.warn("[Gift] autoRemoveGiftIfNeeded failed:", e));
}

}

customElements.define("cart-drawer-items", CartDrawerItems);


